import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import type { PaginatedRequestParams, PaginatedResponse, UserFilterParams } from '@/types/api';

type UseAmelioPaginatedQueryOptions<T> = {
    queryKey: unknown[];
    queryFn: (
        params: PaginatedRequestParams & { signal?: AbortSignal },
    ) => Promise<PaginatedResponse<T>>;
    pageNumber: number;
    pageSize: number;
    options?: Omit<UseQueryOptions<PaginatedResponse<T>, Error>, 'queryKey' | 'queryFn'>;
    meta?: Record<string, unknown>;
    filters?: UserFilterParams;
};

export const useAmelioPaginatedQuery = <T>({
    queryKey,
    queryFn,
    pageNumber,
    pageSize,
    options,
    meta,
    filters,
}: UseAmelioPaginatedQueryOptions<T>) => {
    return useQuery<PaginatedResponse<T>, Error>({
        queryKey: [
            ...queryKey,
            pageNumber,
            pageSize,
            ...(meta ? [meta] : []),
            ...(filters ? [filters] : []),
        ],
        queryFn: ({ signal }) =>
            queryFn({
                pageNumber,
                pageSize,
                meta,
                ...filters,
                signal,
            }),
        ...options,
    });
};
